import { Typography } from "@circle-react-shared/uikit/Typography";

export interface AttributeItem {
  label: string;
  value: string | number | boolean | string[] | null | undefined;
}

interface ConfirmationCardLayoutProps {
  attributes: AttributeItem[];
  title: string;
}

export const ConfirmationCardLayout = ({
  title,
  attributes,
}: ConfirmationCardLayoutProps) => {
  const visibleAttributes = attributes.filter(
    attr =>
      attr.value !== null && attr.value !== undefined && attr.value !== "",
  );

  return (
    <div
      className="bg-primary border-primary flex w-[368px] min-w-0 flex-1 flex-col items-start gap-3 self-stretch rounded-2xl border p-4"
      style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}
    >
      <Typography.BodySm weight="font-bold" color="text-darkest">
        {title}
      </Typography.BodySm>

      <ul className="block w-full text-sm font-normal leading-[0]">
        {visibleAttributes.map(attr => (
          <li
            key={attr.label}
            className="text-darkest mb-0 ms-[calc(1.5*var(--list-marker-font-size,0))] text-sm not-italic leading-5"
          >
            <Typography.BodySm
              as="span"
              weight="font-bold"
              color="text-darkest"
            >
              {attr.label}:{" "}
            </Typography.BodySm>
            <Typography.BodySm as="span" color="text-darkest">
              {String(attr.value)}
            </Typography.BodySm>
          </li>
        ))}
      </ul>
    </div>
  );
};
